import type { BillingSettingsManager } from '@/state/billing/useBillingSettings';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field, FIELD_CONTROL, Panel } from '../../ConsolePanel';

type UsageReportPanelProps = { manager: BillingSettingsManager };

/**
 * A month's sessions, itemised by client and website, as a CSV. The plan's
 * allowance is one pool, so an agency that passes costs on to its clients needs
 * this to show who used what.
 */
export const UsageReportPanel = ({ manager }: UsageReportPanelProps) => {
  const { month, setMonth, isMonthValid, isDownloading, download } = manager.usageReport;

  return (
    <Panel
      tourAnchor="billing-usage-report"
      title="Usage report"
      description="A month's sessions, itemised by client and website."
    >
      <div className="flex flex-wrap items-end gap-3">
        <Field label="Month" htmlFor="billing-usage-report-month">
          <Input
            id="billing-usage-report-month"
            type="month"
            value={month}
            onChange={(ev) => setMonth(ev.target.value)}
            className={FIELD_CONTROL}
          />
        </Field>
        <Button
          variant="outline"
          className="h-9 rounded-lg text-body"
          disabled={!isMonthValid || isDownloading}
          onClick={download}
        >
          <Download className="size-4" strokeWidth={1.5} />
          Download report
        </Button>
      </div>
    </Panel>
  );
};
